// extracted by mini-css-extract-plugin
module.exports = {"globalContainer":"Message_globalContainer__1ele4","show":"Message_show__1wypI"};